'use strict';

var styled = require('styled-components');
var styles = require('../../Text/styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const getTextFullPadding = ({ designTokens }) => `calc(${designTokens.switchTextPaddingX} + ${designTokens.switchToggleSize} + ${designTokens.switchToggleContainerOffset})`;
const Container = styled__default.default.div `
  position: relative;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  min-width: ${({ theme }) => theme.designTokens.switchMinWidth};
  border-radius: ${({ theme }) => theme.designTokens.switchRadius};
  padding-left: ${({ theme, checked }) => checked ? theme.designTokens.switchTextPaddingX : getTextFullPadding(theme)};
  padding-right: ${({ theme, checked }) => checked ? getTextFullPadding(theme) : theme.designTokens.switchTextPaddingX};
  background: ${({ theme, checked, disabled }) => {
    switch (true) {
        case checked && disabled:
            return theme.designTokens.switchCheckedDisabledBackgroundColor;
        case checked:
            return theme.designTokens.switchCheckedBackgroundColor;
        case disabled:
            return theme.designTokens.switchDisabledBackgroundColor;
        default:
            return theme.designTokens.switchBackgroundColor;
    }
}};
  transition: background ${({ theme }) => theme.designTokens.switchCheckUncheckTransition},
    padding-left ${({ theme }) => theme.designTokens.switchCheckUncheckTransition},
    padding-right ${({ theme }) => theme.designTokens.switchCheckUncheckTransition};

  :focus {
    outline: none;
    box-shadow: ${({ theme }) => theme.designTokens.switchFocusShadow};
  }
  &,
  ${styles.Styled.Span} {
    color: ${({ theme }) => theme.designTokens.switchTextColor};
    line-height: ${({ theme }) => theme.designTokens.switchLineHeight};
    height: ${({ theme }) => theme.designTokens.switchLineHeight};
    display: inline-flex;
    align-items: center;
  }
`;
const Toggle = styled__default.default.div `
  display: inline-block;
  width: ${({ theme }) => theme.designTokens.switchToggleSize};
  height: ${({ theme }) => theme.designTokens.switchToggleSize};
  border-radius: 50%;
  background: ${({ theme }) => theme.designTokens.switchToggleBackground};
  position: absolute;
  top: ${({ theme }) => theme.designTokens.switchToggleContainerOffset};
  left: ${({ theme, checked }) => checked
    ? `calc(100% - ${theme.designTokens.switchToggleContainerOffset} - ${theme.designTokens.switchToggleSize})`
    : theme.designTokens.switchToggleContainerOffset};
  transition: left ${({ theme }) => theme.designTokens.switchCheckUncheckTransition};
`;
const Styled = {
    Container,
    Toggle,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
